import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase";
import { parseBasicInfo } from "../components/VenuesList";

// Inventario público para las landings v2 (FRA-284): qué venues mostraría
// cada landing del homesite. Mismo criterio que el backend GET /venues
// (isActive && isActiveAdmin) y mismo join: eventTypes por tag explícito,
// ubicación por zone (basicInfo) === ciudad.name.

export async function fetchPublicVenues() {
  const snap = await getDocs(
    query(
      collection(db, "venues"),
      where("isActive", "==", true),
      where("isActiveAdmin", "==", true)
    )
  );
  return snap.docs.map((d) => {
    const data = d.data();
    return {
      id: d.id,
      name: data.name || "",
      zone: parseBasicInfo(data.basicInfo).zone || null,
      eventTypes: Array.isArray(data.eventTypes) ? data.eventTypes : [],
    };
  });
}

export function venuesForEventType(venues, eventTypeId) {
  return venues.filter((v) => v.eventTypes.includes(eventTypeId));
}

export function venuesForZone(venues, zoneName) {
  return venues.filter((v) => v.zone === zoneName);
}

export function venuesForCombo(venues, eventTypeId, zoneName) {
  return venues.filter(
    (v) => v.eventTypes.includes(eventTypeId) && v.zone === zoneName
  );
}
